import { v4 as uuidv4 } from 'uuid';
import ProjectImg from '../images/img-2.jpg';
import UTrackerImg from '../images/img-3.jpg';
import GreenCtgImg from '../images/img-4.jpg';
import CoinTrackerImg from '../images/img-9.jpg';
import CavinImg from '../images/img-8.jpg';
import CavinImg2 from '../images/img-7.jpg';
import CavinImg3 from '../images/img-10.jpg';
import CavinImg4 from '../images/img-11.jpg';
import CavinImg5 from '../images/img-12.jpg';
import CavinImg6 from '../images/img-13.jpg';
import CavinImg7 from '../images/img-14.jpg';
import CavinImg8 from '../images/img-15.jpg';

const projects = [
  {
    id: uuidv4(),
    name: '',
    desc: '',
    img: CavinImg6,
  },
  {
    id: uuidv4(),
    name: '',
    desc: '',
    img: CavinImg7,
  },
  {
    id: uuidv4(),
    name: '',
    desc: '',
    img: CavinImg8,
  },
  {
    id: uuidv4(),
    name: '',
    desc: '',
    img: CavinImg3,
  },
  {
    id: uuidv4(),
    name: '',
    desc: '',
    img: CavinImg4,
  },
  {
    id: uuidv4(),
    name: '',
    desc: '',
    img: CavinImg5,
  },
  {
    id: uuidv4(),
    name: '',
    desc: '',
    img: UTrackerImg,
  },
  {
    id: uuidv4(),
    name: '',
    desc: '',
    img: GreenCtgImg,
  },
  {
    id: uuidv4(),
    name: '',
    desc: '',
    img: CoinTrackerImg,
  },
  {
    id: uuidv4(),
    name: '',
    desc: '',
    img: CavinImg,
  },
  {
    id: uuidv4(),
    name: '',
    desc: '',
    img: CavinImg2,
  },
  {
    id: uuidv4(),
    name: '',
    desc: '',
    img: ProjectImg,
  },
];

export default projects;
